<template>
  <div id="settings-view" class="custom-scrollbar-grey">
    <HeaderContent :title="$t('settings.settings-heading')">
      <div slot="main">
        <p class="text-muted">
          {{ $t("settings.message") }}
        </p>
      </div>
      <div slot="menu">
        <div class="navigation-links">
          <a href="#account">{{ $t("settings.nav.organization") }}</a>
          <a href="#profile">{{ $t("settings.nav.profile") }}</a>
          <a href="#users">{{ $t("settings.nav.user") }}</a>
          <a href="#api-keys">{{ $t("settings.nav.apikeys") }}</a>
        </div>
      </div>
    </HeaderContent>
    <div id="settings">
      <div class="settings-content flex-grow-1 flex-shrink-1 ">
        <div class="auto-max-width">
          <Account class="settings-area" />
          <Profile class="settings-area" />
          <Users class="settings-area" />
          <ApiKeys class="settings-area" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Account from "@/components/Account.vue";
import Profile from "@/components/Profile.vue";
import Users from "@/components/Users.vue";
import ApiKeys from "@/components/ApiKeys.vue";
import HeaderContent from "@/components/HeaderContent.vue";
export default {
  name: "settings",
  components: {
    Account,
    Profile,
    Users,
    ApiKeys,
    HeaderContent
  },
  data() {
    return {
      collapsed: true
    };
  },
  methods: {
    closePanel() {
      this.collapsed = !this.collapsed;
      this.$emit("toggled", this.collapsed);
      setTimeout(() => {
        this.$emit("close");
      }, 100);
    }
  },
  computed: {}
};
</script>
<style lang="less">
#settings-view {
  scroll-behavior: smooth;
  background-color: var(--bg-grey);
  overflow: auto;

  .navigation-links {
    padding: 4px 0;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    gap: 18px;

    a {
      color: var(--charcoal-75);
      &:hover {
        color: var(--orange-web);
        text-decoration: underline;
      }
    }
  }
}

#settings {
  padding-left: var(--sidebar-width);
  
  .collapser {
    display: none;
  }
  form input {
    // border: none;
    // border-bottom: 1px solid #383838;
    // background-color: transparent;
    background-color: inherit;

    &:focus {
      // background-color: transparent;
      background-color: inherit;
    }
  }
  .settings-categories {
    // background-color: var(--alabaster);
    background-color: var(--background-white);
    box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.25);
    width: 240px;
    height: 100vh;
    min-width: 240px;
    padding: 103px 40px 0 40px;
    h1 {
      margin-bottom: 50px;
    }
  }

  .settings-content {
    overflow: auto;
    h2 {
      font-size: 18px;
      font-weight: 700;
      margin: 0;
    }
  }

  .loading-view {
    filter: blur(2px) brightness(105%);
    transition-delay: 0.2s;
    transition: 0.1s;
  }

  .settings-area {
    
    padding:104px 12px 0 12px;
    .intro-wrapper {
      margin-bottom: 36px;
      .content {
        max-width: 400px;
        h2{
          margin-bottom: 12px;
        }
        .btn-primary-outline {
          width: max-content;
        }
      }
    }
  }
}
#app #settings h3 {
  font-weight: 700;
  color: var(--charcoal-75);
  margin-bottom: 0;
}

@media screen and (min-width: 920px) {
  #settings .settings-area {
    .intro-wrapper {
      display: flex;
      justify-content: center;
      flex-grow: 1;
      .content {
        display: flex;
        flex-direction: column;
        max-width: 400px;
      }
    }
  }
}
</style>
